var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container-max",
      class: { "p-0": _vm.$ceres.isShopBuilder }
    },
    [
      _c(
        "div",
        { staticClass: "position-relative" },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-grow-1 position-relative my-2" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchString,
                    expression: "searchString"
                  }
                ],
                ref: "searchInput",
                staticClass: "search-input flex-grow-1 px-3 py-2",
                attrs: { type: "search", autofocus: _vm.isShopBuilder },
                domProps: { value: _vm.searchString },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.searchString = $event.target.value
                    },
                    function($event) {
                      return _vm.onValueChanged($event.target.value)
                    }
                  ],
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.search()
                  },
                  focus: function($event) {
                    _vm.isSearchFocused = true
                  },
                  blur: function($event) {
                    return _vm.onBlurSearchField($event)
                  }
                }
              }),
              _vm._v(" "),
              _vm._t("search-button", [
                _c(
                  "button",
                  {
                    staticClass: "search-submit px-3",
                    attrs: { type: "submit" },
                    on: {
                      click: function($event) {
                        return _vm.search()
                      }
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-search",
                      attrs: { loading: _vm.autocompleteIsLoading }
                    })
                  ]
                )
              ])
            ],
            2
          ),
          _vm._v(" "),
          _vm.isSearchFocused
            ? [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          (_vm.searchString.length >= _vm.searchMinLength &&
                            _vm.hasInitialInput) ||
                          _vm.$ceres.isShopBuilder,
                        expression:
                          "(searchString.length >= searchMinLength && hasInitialInput) || $ceres.isShopBuilder"
                      }
                    ]
                  },
                  [
                    _vm._t("autocomplete-suggestions", [
                      _c(
                        "div",
                        { staticClass: "autocomplete-suggestions-wrapper row" },
                        [
                          _c("div", { staticClass: "col-lg-4" }, [
                            _c(
                              "div",
                              { staticClass: "autocomplete-suggestions" },
                              [
                                _c("search-suggestion-item", {
                                  attrs: {
                                    "show-images": _vm.showItemImages,
                                    "suggestion-type": "category"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "autocomplete-suggestions" },
                              [
                                _c("search-suggestion-item", {
                                  attrs: {
                                    "show-images": _vm.showItemImages,
                                    "suggestion-type": "suggestion"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-8" }, [
                            _c(
                              "div",
                              { staticClass: "autocomplete-suggestions" },
                              [
                                _c("search-suggestion-item", {
                                  attrs: {
                                    "show-images": _vm.showItemImages,
                                    "suggestion-type": "item"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "autocomplete-suggestions-wrapper__footer"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "autocomplete-suggestions-wrapper__link",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.search()
                                    }
                                  }
                                },
                                [
                                  _vm._v(" Alle Ergebnisse anzeigen für: "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "dia-suggestions__link-fat"
                                    },
                                    [_vm._v(_vm._s(_vm.searchString))]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }